import React, { useEffect, useRef } from "react";

export default function ThreeDSFrame({ html, visible = false, className, height = 520, width = 870 }) {
    const iframeRef = useRef(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe || !html) return;

        if ("srcdoc" in iframe) {
            iframe.srcdoc = html;
        } else {
            const blob = new Blob([html], { type: "text/html" });
            const url = URL.createObjectURL(blob);
            iframe.src = url;
            return () => URL.revokeObjectURL(url);
        }
    }, [html]);

    const display = html ? (visible ? "block" : "none") : "none";

    return (
        <iframe
            ref={iframeRef}
            title="3DS Authentication"
            allowtransparency="true"
            frameBorder="0"
            style={{ display, border: 0, width, height }}
            className={className}
        />
    );
}